import Vue from "vue";
import VueRouter from "vue-router";
import pageRoute from "./pageRoute";

Vue.use(VueRouter);

const routes = [...pageRoute];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});
export default router;
